"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework base class for DataFilterRange controls
         * @internal
         */
        var DataFilterRange = /** @class */ (function (_super) {
            __extends(DataFilterRange, _super);
            function DataFilterRange() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return DataFilterRange;
        }($dyn.ui.Control));
        controls.DataFilterRange = DataFilterRange;
        DataFilterRange.prototype.LinkedId = "";
        DataFilterRange.prototype.FormPartType = "Part";
        DataFilterRange.prototype.RangeValue = "";
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DataFilterRange.js.map
